import type { SharedUiColorNameV2 } from '@/shared/ui/theming';
import type { ButtonStyle } from '@/ui/button/ui-button';
import { Component, computed, output, ChangeDetectionStrategy } from '@angular/core';
import { type AdvizeoModalComponent, injectAdvizeoModalInput } from '../../advizeo-modal-spawner/advizeo-modal-spawner.component';

export interface AdvizeoDialogModalInput {
    title: string;
    message?: string;
    buttons?: AdvizeoDialogModalButton[];
}

export interface AdvizeoDialogModalButton {
    text: string;
    onClick: (() => void) | 'cancel';
    color: SharedUiColorNameV2;
    buttonStyle?: ButtonStyle;
}

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./advizeo-dialog-modal.scss'],
    selector: 'advizeo-dialog-modal',
    templateUrl: 'advizeo-dialog-modal.html'
})
export class AdvizeoDialogModalComponent implements AdvizeoModalComponent<AdvizeoDialogModalInput, boolean> {
    input = injectAdvizeoModalInput<AdvizeoDialogModalInput>();
    close = output<boolean | undefined>();

    title = computed(() => this.input().title);
    buttons = computed(() => {
        return (
            this.input().buttons?.map(buttonConfig => ({
                text: buttonConfig.text,
                onClick: () => {
                    if (buttonConfig.onClick === 'cancel') {
                        this.close.emit(true);
                    } else {
                        buttonConfig.onClick();
                        this.close.emit(true);
                    }
                },
                color: buttonConfig.color,
                buttonStyle: buttonConfig.buttonStyle
            })) ?? []
        );
    });
    isDismissable = computed(() => (this.input().buttons ?? []).findIndex(button => button.onClick === 'cancel') > -1);
}
